export class RouteVehicleDTO {
    constructor(
        public id: number,
        public licencePlate: string,
        public capacity: number
    ) {}
}
